import { getItemsByJob } from './syncQueue';

export type JobSyncStatus =
  | 'idle' // no local queue items
  | 'synced' // all items confirmed
  | 'in-progress' // at least one uploading
  | 'pending-sync' // pending items waiting
  | 'sync-failed'; // at least one failed

export interface JobSyncSummary {
  status: JobSyncStatus;
  queuedCount: number;
  failedAtSequence?: number;
}

export async function summarizeJobSync(jobId: string): Promise<JobSyncSummary> {
  const items = await getItemsByJob(jobId);
  if (items.length === 0) {
    return { status: 'idle', queuedCount: 0 };
  }
  const failed = items.find((x) => x.status === 'failed');
  if (failed) {
    return {
      status: 'sync-failed',
      queuedCount: items.filter((x) => x.status !== 'confirmed').length,
      failedAtSequence: failed.sequence_index,
    };
  }
  const uploading = items.some((x) => x.status === 'uploading');
  const pending = items.filter((x) => x.status === 'pending').length;
  if (uploading || pending > 0) {
    return {
      status: pending > 0 ? 'pending-sync' : 'in-progress',
      queuedCount: pending + (uploading ? 1 : 0),
    };
  }
  return { status: 'synced', queuedCount: 0 };
}

export function statusBorderClass(s: JobSyncStatus): string {
  switch (s) {
    case 'synced':
      return 'border-l-eva-teal';
    case 'in-progress':
      return 'border-l-bracket-blue';
    case 'pending-sync':
      return 'border-l-bracket-amber';
    case 'sync-failed':
      return 'border-l-red-500';
    case 'idle':
      return 'border-l-transparent';
  }
}

export function statusLabel(s: JobSyncStatus): string {
  switch (s) {
    case 'synced':
      return 'synced';
    case 'in-progress':
      return 'uploading';
    case 'pending-sync':
      return 'pending sync';
    case 'sync-failed':
      return 'sync failed';
    case 'idle':
      return '';
  }
}
